import { Outlet, Scripts, ScrollRestoration, useLoaderData, useLocation } from 'react-router';
import { ExternalScripts } from 'remix-utils/external-scripts';

import { usePlusConfig } from '~/providers/plus-config-context';
import {
  computeDataTemplate,
  GoogleTagManagerBody,
  shouldRenderGtm,
} from '~/vendor/cx-web/components/third-party/google-tag-manager';
import { featureFlags, useFeatureFlag } from '~/vendor/cx-web/feature-flags/feature-flag-provider';
import { REPUB_CONFIG } from '~/vendor/cx-web/repub-config';

import { type loader } from './root-loader';

export default function Body() {
  const rootLoaderData = useLoaderData<typeof loader>();
  if (!rootLoaderData) {
    throw new Error('Root loader data is missing');
  }

  const { pathname } = useLocation();
  const disableGtm = useFeatureFlag(featureFlags.DISABLE_GOOGLE_TAG_MANAGER);
  const disableOffersWidgets = useFeatureFlag(featureFlags.DISABLE_OFFER_WIDGETS);

  const { ENV, gtmId, repub, resourcesUrl } = rootLoaderData;

  const { uiBehavior } = usePlusConfig();
  const theme = uiBehavior.theme;

  return (
    <body
      data-fpsm-theme={theme}
      data-template={computeDataTemplate(pathname)}
      style={
        theme === 'whoscored'
          ? ({
              '--ws-background-url': `url(${resourcesUrl}/assets/img/plus/ws-background.png)`,
            } as React.CSSProperties)
          : undefined
      }
    >
      {!REPUB_CONFIG[repub]?.tracking?.usesConsentGatedGTM && (
        <GoogleTagManagerBody gtmId={gtmId} shouldRender={!disableGtm && shouldRenderGtm(ENV.ENVIRONMENT)} />
      )}
      <Outlet context={rootLoaderData} />
      <script
        dangerouslySetInnerHTML={{
          __html: `window.ENV = ${JSON.stringify(ENV)}`,
        }}
      />
      <ScrollRestoration />
      {!disableOffersWidgets && <ExternalScripts />}
      <Scripts />
    </body>
  );
}
